import type { Action } from "~/types/layout";
import type { PBCollection } from "~/types/pb/collections";
import type { PBEnums } from "~/types/pb/enums";

export enum ObjectStorageManageMode {
  Client = "client",
  Partner = "reseller",
  Both = "both"
}

export type PBCustomer = {
  id: string;
  username?: string;
  role: PBEnums.Roles;
  abonnements: PBEnums.SubscriptionType[];
  customerId?: string;
  parent?: string;
  reference: string;
  created: Date;
  quotaAllowed: number;
  isActivated: boolean;
  // isLeviiaActivated: boolean;
  mode: ObjectStorageManageMode;

  // Not sure about keeping these fields here
  allowed: number;
  isLoadingAllowed: boolean;
  updatedAt?: string;
  usedQuota: number;
};

export type PBCreateUser = {
  email: string;
  password: string;
  passwordConfirm: string;
  nom: string;
  prenom: string;
  abonnements?: PBEnums.SubscriptionType[];
  parent?: string;
  reference: string;
  emailVisibility: boolean;
};

export type PBTeamMember = PBCollection.Customer & {
  role: PBEnums.Roles;
  twoFactorEnabled: boolean;
};

export type PBTeamMembers = Record<PBCollection.Customer["id"], PBTeamMember>;

export type CreateUser = {
  email: string;
  firstname: string;
  lastname: string;
  username: string | null;
  error?: string;
};

export interface TeamMemberData {
  id: string;
  email: string;
  creationDate: string;
  hasTwoFactor: boolean;
  role: PBEnums.Roles;
  canDelete: boolean;
  actions: Action[];
}

export interface ClientData {
  id: string;
  teamId: string;
  ref: string;
  creationDate: Date;
  subscriptionEnd: Date | string;
  subscriptionStart: Date | string;
  // product: string;
  storage: number;
  quota: number;
  isActive: boolean;
  mode: ObjectStorageManageMode | null;
  loading: boolean;
}

export type PBRawAlert = {
  id: string;
  created: string;
  subscription: string;
  limitSizePercent: number;
  emailRequired: string;
  emailOptional?: string;
  isActivated?: boolean;
};

export interface ObjectStorageAlertData {
  id: PBRawAlert["id"];
  name: string;
  created: Date;
  limit: number;
  emails: string[];
  isActive: boolean;
}
